<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="printItem" v-for="(item, index) in codeInfo" :key="index">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3" style="width: 100px">
              <div :id="'qrCode' + item.serialNo" align="center" />
            </td>
            <td colspan="2">{{ item.serialNo }}</td>
          </tr>
          <tr>
            <td>{{ item.billNO }}</td>
            <td v-if="item.serialNoType === 10 && item.minPackageQuantity === 0">{{ 1 }}{{ item.unitName ? item.unitName : "" }}</td>
            <td v-else-if="item.serialNoType === 10">{{ item.minPackageQuantity }}{{ item.unitName ? item.unitName : "" }}</td>
            <td v-else-if="item.serialNoType === 20">{{ item.boxQuantity }}{{ item.unitName ? item.unitName : "" }}</td>
          </tr>
          <tr>
            <td colspan="2">{{ item.materialName ? item.materialName.substring(0, 20) : "" }}</td>
          </tr>
          <tr>
            <td colspan="3">规格：{{ item.specification }}</td>
          </tr>
          <tr>
            <td colspan="3">备注：{{ item.note }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      codeInfo: [],
    };
  },

  created() {
    this.codeInfo = JSON.parse(this.$route.query.params);
  },

  mounted() {
    for (let item of this.codeInfo) {
      this.$nextTick(() => {
        document.getElementById("qrCode" + item.serialNo).innerHTML = "";
        this.bindQRCode(item.serialNo);
      });
    }
  },

  methods: {
    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 80,
        height: 80,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 76mm;
  height: 36mm;
  border: 0.5mm solid #666;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    tr {
      td {
        border-bottom: 0.5mm solid #666;
        border-right: 0.5mm solid #666;
        padding: 0 3px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
